import type { FaireProductEntity } from "../../entity_types/product";

export const p_t52g4jqvpq: FaireProductEntity = {
  token: "p_t52g4jqvpq",
  type: "product",
  name: "Two-tone Geometric U-Shape Ear Cuff Gold Plated  N6C182",
  brandToken: "b_vzcwf2s2c8",
  brandName: "alberalkirk",
  imageUrl:
    "https://cdn.faire.com/fastly/cd8ebc72177ba68a8a3c125336c8c662aa39d265e4b4ecebbf76531744ac54b1.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2cfb92904b9d46415b8427e32e928b1ce9450c09e676c9fb0501cc9d263d552c.jpeg",
    "https://cdn.faire.com/fastly/e4b79a625fab3facd2ce4e5422f9f623ebd6e117e1c7fd3f540b415d5b8686c6.jpeg",
    "https://cdn.faire.com/fastly/0dec7c3cf13740e7612724b34eb67f85d08cc9707ad084a124a02262d0061513.jpeg",
    "https://cdn.faire.com/fastly/48cadd4dc3880d80dcd50cebfdd264a6382b37f57a5a8ec8b183a913580bfc48.jpeg",
    "https://cdn.faire.com/fastly/7bfb6f00c60b2c5cd0bb18eac0c7b02208f3bf106ba63829bfe2152291a0142f.jpeg",
    "https://cdn.faire.com/fastly/198968007d9895eba9b3c5f2f4482c653233c8fe2bccc2dd7d9aad30b1231102.jpeg",
    "https://cdn.faire.com/fastly/55f67f9320e00d8d4d8717bbea3177dad93aa7e395a5146c2d0eba5ef9ba4b12.jpeg",
    "https://cdn.faire.com/fastly/bf8b510037fa9b57058a1bddb9cc345558ef0ad3a41d7609d3b02e57da92535e.jpeg",
    "https://cdn.faire.com/fastly/4a910e09b73cb4fcdfc6c832141bf41fbb9a15d2678f3b7ed1b577466459b2c6.jpeg",
    "https://cdn.faire.com/fastly/7aeb9189f047ed61ff80153d64801e69c3ffa7e7bdd4abf9ab97ddd024481224.jpeg",
    "https://cdn.faire.com/fastly/24b07e5700c3f8fb3e86b519b4cfbaa1d6c1682e914fc502929c5b1fca0efbee.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "Material:\n Copper with 18K Gold and Silver Plating \n\n Weight:\n 50g \n\n Package:\n Single Piece \n\n Feature:\n Modern two-tone design in 18K gold and silver for a sleek look\n Unique geometric cross-over shape in a minimalist U-shaped cuff\n High-quality plating ensures a durable and tarnish-resistant finish\n Available in multiple color options for versatile personal styling \n\n Note:\n Please refer to the size chart for dimensions",
  tags: [],
  msrpDollars: 20.79,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:09.601Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
